import moment from "moment";
import { CaseDetail } from "../../models/CaseDetail/caseDetail.model";
import { BodyPartTypeEnum } from "../../enums/BodyPartType.enum";

export const stopPropogateEvent = (e: any) => e.stopPropagation();

export const copyCaseDetailsToClipboard = async (
  caseDetail: CaseDetail,
  targetUrl: string
) => {
  const { scanCenterName, patientName, scanTypeName, createdAt } = caseDetail;
  const bodyParts = (caseDetail?.caseBodyParts ? caseDetail?.caseBodyParts : [])
    .map((bodyPart) => bodyPart.bodyPartName)
    .join(",");
  const studyName = `${scanTypeName}${
    bodyParts !== BodyPartTypeEnum.NOT_SET ? "-" + bodyParts : ""
  }`;
  const text = `
Dear Sir/Mam,  

Warm greetings from ${scanCenterName}.  

Please find the patient details below:  

Patient Name: ${patientName}  
Study Type: ${studyName}  
Date: ${moment(createdAt).format("DD/MM/YYYY")}  

To view the images, click on the following link:  
${targetUrl}`;

  setTimeout(() => {
    navigator.clipboard.writeText(text);
  }, 0);
};

// Copies a base64 data URI (e.g. data:image/png;base64,...) to the system
// clipboard as an actual image blob, so the user can paste it into WhatsApp,
// Slack, Docs, email, etc. and have it show up as a picture rather than the
// raw base64 string.
//
// Uses the async Clipboard API with `ClipboardItem`. This requires a secure
// context (HTTPS / localhost) and a user gesture. We wrap the blob resolution
// in a Promise passed directly to `ClipboardItem` so Safari preserves the
// user-activation context across the await (the write call must be synchronous
// from Safari's point of view). Browsers that don't support
// `navigator.clipboard.write` (older Firefox, etc.) fall back to a legacy
// data-URL write via `writeText` so at minimum the user can paste the data URI
// into a browser tab to view the QR.
export const copyImageToClipboard = async (
  dataUri: string
): Promise<boolean> => {
  if (!dataUri) return false;

  try {
    if (
      typeof window !== "undefined" &&
      typeof (window as any).ClipboardItem !== "undefined" &&
      navigator.clipboard &&
      typeof navigator.clipboard.write === "function"
    ) {
      const ClipboardItemCtor = (window as any).ClipboardItem;
      const blobPromise = fetch(dataUri).then((r) => r.blob());
      const item = new ClipboardItemCtor({ "image/png": blobPromise });
      await navigator.clipboard.write([item]);
      return true;
    }
  } catch (err) {
    // Fall through to text fallback below.
  }

  try {
    await navigator.clipboard.writeText(dataUri);
    return true;
  } catch {
    return false;
  }
};
